import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';
import {
  getMetricFactTable,
  getMetricState,
  metricRouteRef,
} from '@spotify/plugin-confidence-metrics-react';

import { metricsPlugin } from '../plugin';

export const MetricCollectionEntryExtension = metricsPlugin.provide(
  createCollectionEntryExtension({
    id: 'metric',
    resourceType: 'Metric',
    routeRef: metricRouteRef,
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource && resource.__typename === 'MetricsV1Metric',
    render: () => null,
    columns: [
      { id: 'state', getValue: getMetricState },
      { id: 'factTable', getValue: getMetricFactTable },
    ],
  }),
);
